import { formatNumber } from "@angular/common";
import {
  Component,
  HostListener,
  Inject,
  LOCALE_ID,
  OnInit,
} from "@angular/core";
import { AnimationItem } from "lottie-web";
import { AnimationOptions } from "ngx-lottie";
import { ConverterService } from "./modules/shell/services/converter.service";
import { DataService } from "./modules/shell/services/data.service";
import { IImmoconnData } from "./modules/shell/interfaces/immoconnData.interface";
import {
  IDataGWResponse,
  IImmoConnDataGPIOItem,
  IImmoConnDataOneWireItem,
} from "./modules/shell/interfaces/iotMaxxGateway.response";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  public serialNo: string | undefined;
  public minPressureText: string | undefined;
  public maxPressureText: string | undefined;
  public shaft1Open: boolean | undefined;
  public shaft2Open: boolean | undefined;
  public pump1Type: number | undefined;
  public pump2Type: number | undefined;
  public pump3Type: number | undefined;

  public pump1OnTreshold: number | undefined;
  public pump2OnTreshold: number | undefined;
  public pump3OnTreshold: number | undefined;

  public pumpOptions: string[] = ["-", "10A", "20A"];

  public immoconnData?: IImmoconnData;

  public showLoading: boolean = false;

  public options: AnimationOptions = {
    path: "./assets/pinjump.json",
  };
  private anim: any;
  private isLoadingData: boolean = false;

  @HostListener('window:resize', ['$event']) onResize(event) {
    this.calculateVh();
  }

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    public dataService: DataService,
    public convertService: ConverterService
  ) {}

  ngOnInit(): void {
    this.calculateVh();
  }
  public isGetDataPossible(): boolean {
    if (this.serialNo && !this.isLoadingData) {
      return true;
    }
    return false;
  }
  // public async loadData() {
  //   console.log(this.serialNo);
  //   if (this.serialNo) {
  //     this.showLoading = true;
  //     this.isLoadingData = true;
  //     const result = await this.dataService.getData(this.serialNo, "immoconn");
  //     this.showLoading = false;
  //     this.isLoadingData = false;
  //     if (result) {
  //       const immoconnData =
  //         this.convertService.convertGatewayDataToImmoconnData(
  //           result,
  //           this.minPressureText,
  //           this.maxPressureText,
  //           this.shaft1Open,
  //           this.shaft2Open,
  //           this.pump1Type,
  //           this.pump2Type,
  //           this.pump3Type
  //         );
  //       if (immoconnData) {
  //         this.immoconnData = immoconnData;
  //       }
  //     }
  //   }
  // }

  changePumpType($event: Event, usedPump: number) {
    if ($event && $event.target) {
      if ($event.target as HTMLInputElement) {
        const target = $event.target as HTMLInputElement;
        const usedPumpType = this.getPumpeValueFromHtml(target);
        if (usedPump == 1) {
          this.pump1Type = usedPumpType;
        } else if (usedPump == 2) {
          this.pump2Type = usedPumpType;
        } else if (usedPump == 3) {
          this.pump3Type = usedPumpType;
        }
      }
    }
  }

  public getPumpState(threshold?: number, currentValue?: number): string {
    if (threshold && currentValue) {
      var result;
      if (threshold < currentValue) {
        result = true;
      } else {
        result = false;
      }
      return this.getSwitchString(result);
    }
    return "-";
  }

  public getTemperatureString(value?: number): string {
    return this.getNumberString(value, "°C");
  }

  public getPressureString(value?: number): string {
    return this.getNumberString(value, "bar");
  }

  public getRawString(value?: number): string {
    return this.getNumberString(value, "");
  }

  animationCreated(animationItem: AnimationItem): void {
    console.log(animationItem);
  }

  stop() {
    this.anim.stop();
  }

  play() {
    this.anim.play();
  }
  private getNumberString(value: number | undefined, unit: string): string {
    if (value != undefined) {
      const result = formatNumber(value, this.locale);
      return `${result} ${unit}`;
    }
    return "-";
  }

  public getSwitchString(value?: boolean): string {
    if (value != undefined) {
      return this.getBooleanString(value, "AN", "AUS");
    }
    return "-";
  }

  public getTriggerString(value?: boolean): string {
    if (value != undefined) {
      return this.getBooleanString(value, "AUSGELÖST", "NICHT AUSGELÖST");
    }
    return "-";
  }

  private getBooleanString(
    value: boolean | undefined,
    trueStr: string,
    falseStr: string
  ): string {
    if (value != undefined) {
      if (value) {
        return trueStr;
      } else {
        return falseStr;
      }
    }
    return "-";
  }

  private getPumpeValueFromHtml(element: HTMLInputElement): number | undefined {
    var newValue = element.value;
    if (newValue) {
      if (newValue == "10A") {
        return 10;
      } else if (newValue == "20A") {
        return 20;
      }
    }
    return undefined;
  }

  private calculateVh() {
    // First we get the viewport height, and we multiply it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }
}
